// extracted by mini-css-extract-plugin
export default {"companySelectForm":"CompanySelectForm_companySelectForm__z5q6y","form":"CompanySelectForm_form__JzDLc"};